module.exports = __webpack_public_path__ + "static/media/background.a9f79c57.svg";